import { ArrowIcon, Badge, Card, Heading, Stack } from '@autoplan/web-ui'
import temporaryFeaturedNews from '../../../public/temporary-featured-news.png'
import { useLocale } from '@autoplan/web-sanity'

type NewsFeaturedCardProps = {
  title: string
  imageSrc?: string
  onClick: () => void
  className?: string
}

export const NewsFeaturedCard = ({
  title,
  imageSrc = temporaryFeaturedNews,
  onClick,
  className = '',
}: NewsFeaturedCardProps) => {
  const { t } = useLocale()

  return (
    <Card
      onClick={onClick}
      className={`ap:group ap:relative ap:flex ap:flex-col ap:h-[220px] ap:overflow-hidden ${className}`}
    >
      <img
        src={imageSrc}
        alt={title}
        className="ap:absolute ap:inset-0 ap:h-full ap:w-full ap:object-cover ap:transition-transform ap:duration-300 ap:group-hover:scale-[1.02]"
      />
      <div className="ap:absolute ap:inset-0 ap:bg-linear-to-r ap:from-[#000000]/85 ap:via-[#000000]/55 ap:to-[#000000]/10" />

      <div className="ap:relative ap:z-10 ap:flex ap:flex-col ap:justify-between ap:p-2xl ap:flex-1">
        <div className="ap:flex ap:items-start ap:justify-end">
          <span className="ap:text-content-inverse ap:bg-surface-disabled/20 ap:cursor-pointer ap:p-md ap:group-hover:bg-surface-disabled/45 ap:rounded-full ap:transition-colors">
            <ArrowIcon />
          </span>
        </div>
        <Stack spacing="md">
          <Badge variant="primary">{t('home.news.badge')}</Badge>
          <Heading size="xl" className="ap:text-content-inverse ap:text-start">
            {title}
          </Heading>
        </Stack>
      </div>
    </Card>
  )
}
